import CostCenterBaseController from '../common/cost_center.base.controller';

class CostCenterCreateController extends CostCenterBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, CostCenterService, Modal, $translate, $stateParams, CommonLayoutService) {
        super(Auth, $state, User, CostCenterService, Modal, $translate, $stateParams)
        this.Auth = Auth
        this.$state = $state
        this.User = User
        this.CommonLayoutService = CommonLayoutService;
        this.defaultModel = {
            status: true,
            name: null,
            description: null,
            customerFlag: false
        }
        this.branchId = this.User.getUser().branchId;
        this.model = angular.copy(this.defaultModel)
        this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: this.$translate.instant('common.yes'),
                off: this.$translate.instant('common.no')
            },
            onColor: 'success',
            offColor: 'danger'
        }
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.clearErrors();
    }

    submit() {
        this.loading = true;
        this.Service.create({
            name: this.model.name,
            description: this.model.description,
            status: this.model.status,
            customerFlag: this.model.customerFlag
        }, this.branchId)
            .then(() => {
                this.loading = false;
                this.askCreate();
            })
            .catch((err) => {
                this.loading = false;
                if (err && err.data && err.data.errors) {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                }
                else {
                    this.errorMessage = err.data.message;
                }
            })
    }
}

export default CostCenterCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/create/cost_center.create.controller.js